import type { GetCourseDrafts200ContentItem } from './getCourseDrafts200ContentItem';
import type { GetCourseDrafts200Pageable } from './getCourseDrafts200Pageable';

/**
 * 페이징된 코스 초안 목록
 */
export type GetCourseDrafts200 = {
  /** 코스 초안 목록 */
  content: GetCourseDrafts200ContentItem[];
  /** 빈 페이지 여부 */
  empty: boolean;
  /** 첫 번째 페이지 여부 */
  first: boolean;
  /** 마지막 페이지 여부 */
  last: boolean;
  /** 현재 페이지 번호 (0부터 시작) */
  number: number;
  /** 현재 페이지의 요소 수 */
  numberOfElements: number;
  /** 페이징 정보 */
  pageable?: GetCourseDrafts200Pageable;
  /** 페이지 크기 */
  size: number;
  /** 전체 요소 수 */
  totalElements: number;
  /** 전체 페이지 수 */
  totalPages: number;
};
